import { ID } from './id';
import { Timestamp } from './timestamp';

export type ConnectionCalendar = ExternalCalendar & { connectionId: ID };

// Backend-maintained doc at external-connections/{id}/runtime/calendars
export type ExternalConnectionCalendarsCache = {
  id: ID;
  calendars: ExternalCalendar[];
  updatedAt: Timestamp | null;
};

// Why the backend permanently refuses to sync a calendar (runtime/calendars →
// writeBlockedCalendars). Blocked is the forward-compat fallback: a kind this
// client version doesn't know yet renders the generic message instead of a
// remedy hint that may be wrong.
export enum WriteBlockedKind {
  Access = 'access',
  NotACalendar = 'not-a-calendar',
  Deleted = 'deleted',
  Blocked = 'blocked',
}

export type ExternalCalendar = {
  id: ID;
  name: string;
  description: string;
  color: string;
  timeZone?: string | null;
  // absent → treat as true (legacy backend listed only writable calendars)
  canWrite?: boolean;
  // absent → treat as false (never offer a video-call link we can't create)
  supportsVideoCall?: boolean;
  // absent → not blocked; set → the backend skips every write to this calendar
  writeBlocked?: WriteBlockedKind;
};
